import { useMemo } from 'react';
import { useScreenFromRoute } from '../../hooks/useScreenFromRoute';
import { useFeaturesByApiNames } from './useFeaturesByApiNames';
export const useFormattedFeatureTableBodyData = ({
  productApiNames,
  i18nLangLocale = 'en'
}) => {
  const screen = useScreenFromRoute();
  const featuresByApiNames = useFeaturesByApiNames({
    productApiNames,
    i18nLangLocale
  });
  const formattedFeatureTableBodyData = useMemo(() => {
    const tableBodyData = {
      sharedData: {
        subscreen: screen || ''
      },
      sectionData: {}
    };
    if (featuresByApiNames.data) {
      tableBodyData.sectionData = {
        all: {
          LabelContent: 'All features',
          features: featuresByApiNames.data,
          alwaysExpanded: false,
          // @ts-expect-error FeatureTable expects ApiName type
          apiNames: productApiNames
        }
      };
    }
    return tableBodyData;
  }, [featuresByApiNames.data, screen, productApiNames]);
  return {
    data: formattedFeatureTableBodyData || undefined,
    loading: featuresByApiNames.loading,
    error: featuresByApiNames.error
  };
};